import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { GET_STATES } from '../../../queries'

export default function States (): JSX.Element {
  const { filters, setFilters } = useContext(EventsFiltersContext)
  const { loading, error, data } = useQuery(GET_STATES)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations.states) return <p>No data found</p>

  const geoipStates: Array<string> = []
  data.ordersAggs.aggregations.states.buckets.map((state: any) => {
    geoipStates.push(state.key)
  })

  const onChange = (value: string[]) => {
    setFilters({
      geoipStates: value
    })
  }

  const typographLabel = 'Estado'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={geoipStates}
        defaultValues={filters.geoipStates}
        onChange={onChange}
      />
    </Fragment>
  )
}
